var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPrompt)?_c('div',{staticClass:"prompt"},[_vm._v(" Double-click on any area to navigate through the interactive map. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }